export default __webpack_public_path__ + "images/04b281892045da7487fce6bde63e3b8e-health.jpg";